import React from 'react'

import {Grid} from 'react-flexbox-grid'

const Container = (props) => {
  return <Grid data-testid="test-container" {...props} style={
    {
      paddingLeft: props.padding ? props.padding : '64px',
      paddingRight: props.padding ? props.padding : '64px',
      width: props.width ? props.width : '1440px',
      position: props.position ? props.position : '',
      background: props.background ? props.background : ''
    }} />
}

export default Container
